// extracted by mini-css-extract-plugin
export default {"closeWhatIsTopcoderVideoCross":"_3HjNSl","whatIsTopcoderVideo":"_3iOAMW","watchVideoButton":"_11ZocD"};